export enum ChangePasswordMessages {
  currentPasswordInstruction = "changePassword.currentPasswordDescription",
  currentPasswordLabel = "changePassword.currentPasswordLabel",
  newPasswordInstruction = "changePassword.currentPasswordInstruction",
  newPasswordLabel = "changePassword.newPasswordLabel",
  confirmPasswordInstruction = "changePassword.confirmPasswordInstruction",
  currentPasswordRequired = "changePassword.currentPasswordRequired",
  newPasswordRequired = "changePassword.newPasswordRequired",
  confirmPasswordRequired = "changePassword.confirmPasswordRequired",
  newPasswordMinimumLength = "changePassword.newPasswordMinimumLength",
  confirmPasswordNotMatch = "changePassword.confirmPasswordNotMatch",
  changePasswordSuccess = "changePassword.success",
  changePasswordFailed = "changePassword.failed",
  changePasswordButtonTitle = "changePassword.buttonTitle",
}

export interface TranslationChangePasswordMessages {
  [ChangePasswordMessages.currentPasswordInstruction]: string;
  [ChangePasswordMessages.currentPasswordLabel]: string;
  [ChangePasswordMessages.newPasswordInstruction]: string;
  [ChangePasswordMessages.newPasswordLabel]: string;
  [ChangePasswordMessages.confirmPasswordInstruction]: string;
  [ChangePasswordMessages.currentPasswordRequired]: string;
  [ChangePasswordMessages.newPasswordRequired]: string;
  [ChangePasswordMessages.confirmPasswordRequired]: string;
  [ChangePasswordMessages.newPasswordMinimumLength]: string;
  [ChangePasswordMessages.confirmPasswordNotMatch]: string;
  [ChangePasswordMessages.changePasswordSuccess]: string;
  [ChangePasswordMessages.changePasswordFailed]: string;
  [ChangePasswordMessages.changePasswordButtonTitle]: string;
}